import $ from 'jquery';

const defaults = {
  defaultText: 'Select',
  addReadMore: true,
};

export default class Selection {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign({}, defaults, options);
    this.select = this.createSelect();
    this.addOptions();
    this.ready();
  }

  createSelect() {
    // creates a select element.
    const select = document.createElement('select');
    select.addEventListener('change', this.change);
    // creates a default option of our select element.
    const defaultOption = document.createElement('option');
    defaultOption.text = this.settings.defaultText;
    defaultOption.disabled = true;
    defaultOption.selected = true;
    select.appendChild(defaultOption);
    // adds a wrapper to aid styling.
    const dropdown = document.createElement('div');
    dropdown.className = 'dropdown';
    // inserts the select it's dropdown wrapper to the document.
    dropdown.appendChild(select);
    this.$element.find('.node-links').prepend(dropdown);
    return select;
  }

  // Creates options based on values of the related links of the post.
  addOptions() {
    // Add related links.
    this.$element.find('.link-related a').each((i, link) => {
      this.select.appendChild(this.createOption(link));
    });

    // Add read more link?
    if (this.settings.addReadMore) {
      this.$element.find('.link-read-more a').each((i, link) => {
        this.select.appendChild(this.createOption(link));
      });
    }
  }

  /* eslint-disable-next-line */
  createOption(link) {
    const option = document.createElement('option');
    option.value = link.href;
    option.text = link.text;
    return option;
  }

  // Redirect user to the href value of option.
  change() {
    window.location.href = this.value;
  }

  // Mark the block ready.
  ready() {
    this.$element.addClass('ready');
  }
}
